import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { PollService } from '@services/poll.service';
@Component({
  selector: 'app-poll-result',
  templateUrl: './poll-result.component.html',
  styleUrls: ['./poll-result.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class PollResultComponent implements OnInit {
  application = "poll";
  component = 'm';
  page_load=true;
  pollId='';
  response:any=[];
  questions: any = [];
  answers: any = {};
  question_no = 0;
  total_question = 0;
  btn_show: any = {};
  questionids:any=[];
  pollJson:any=[];
  constructor(private _pollervice: PollService,public ngxSmartModalService: NgxSmartModalService, private _mail: MailService,  private router: Router, private _commonPipe: CommonPipe,  private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {
 this.pollId=this.route.snapshot.url[1].path;
    let p = {
      'component': this.component,
      'application': this.application,
      'id': this.pollId
    };
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.page_load=false;
          this.response = this._global.getVal(data, 'response', {});
          this.pollJson=this.response['pollJson'];
          this.questions=this.response['pollJson']['questions'];
          this.total_question = this._global.getVal(this.pollJson,'numQuestions',0);
          if (this.total_question == 1) {
            this.btn_show['submit'] = true;
          } else if (this.total_question > 1) {
            this.btn_show['next'] = true;
          }
        
         
          this._global.addMetaInfo(this.response, 'view','name');
       
         
        }else{
          this.router.navigate(['']);
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
        this.router.navigate(['']);
      });
  }

  ngOnInit(): void {
  }
  getQuesAnswer(event){
    console.log("dial event", event.target.value)
  }
  geDays(event){
    console.log("dial event", event.target.value)
  }
}
